window.addEventListener('load', function () {
    function initializeFilters() {
        const selects = document.querySelectorAll('.cmp-combobox select');

        for (const select of selects) {
            if (select.tomselect) {
                select.tomselect.destroy();
            }
            new TomSelect(select, {
                hidePlaceholder: true,
                plugins: {
                    remove_button: {
                        title: 'Remove this item',
                    },
                },
                sortField: [{ field: '$order' }, { field: '$score' }],
                onInitialize() {
                    this.focus_node
                        .closest('.cmp-combobox')
                        .classList.add('cmp-combobox--initialized');
                    this.focus_node.setAttribute('readonly', '');
                },
            });
        }
    }

    initializeFilters();
    document.addEventListener('facets-rerender', initializeFilters);
});
